import React from 'react';
import {useAppSelector} from '../store/hooks';
import Hero from '../components/marketing/Hero';
import Features from '../components/marketing/Features';
import PricingContainer from '../components/pricing.container';
import {isAuthenticatedSelector} from '../store/selectors/auth.selectors';

const LandingPage: React.FC = () => {
  const isAuthenticated = useAppSelector(isAuthenticatedSelector);

  return (
    <>
      <Hero isAuthenticated={isAuthenticated} />
      <Features />
      <PricingContainer />
    </>
  );
};

export default LandingPage;
